import {
  IAccountingJournalEntryRepository,
  IGetAccountingJournalEntriesRepositoryParams,
  IGetAccountingJournalEntriesRepositoryResponse,
} from "@/core/repositories/accounting/IAccountingJournalEntry.repository";

export class GetAccountingJournalEntriesUseCase {
  constructor(private readonly repository: IAccountingJournalEntryRepository) {}

  public async execute(
    params: IGetAccountingJournalEntriesRepositoryParams,
    refetch: boolean = false
  ): Promise<IGetAccountingJournalEntriesRepositoryResponse> {
    return this.repository.getAccountingJournalEntries(params, refetch);
  }
}
